import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=6a3d6a34"
import script from "./FormInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=6a3d6a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QMenu,QField});
